import { useState, useEffect } from 'react';
import { useParams, Routes, Route, Navigate } from 'react-router-dom';
import { guildsAPI } from '../api';
import { useAuth } from '../context/AuthContext';
import DashboardLayout from '../components/layout/DashboardLayout';
import OverviewPage from './dashboard/OverviewPage';
import StaffPage from './dashboard/StaffPage';
import ShiftsPage from './dashboard/ShiftsPage';
import RanksPage from './dashboard/RanksPage';
import PayrollPage from './dashboard/PayrollPage';
import BonusesPage from './dashboard/BonusesPage';
import ConfigPage from './dashboard/ConfigPage';
import PanelPage from './dashboard/PanelPage';
import LogsPage from './dashboard/LogsPage';
import KeysPage from './dashboard/KeysPage';
import PartnersPage from './dashboard/PartnersPage';
import SubscriptionPage from './dashboard/SubscriptionPage';
import RequestsPage from './dashboard/RequestsPage';
import ApplicationsPage from './dashboard/ApplicationsPage';
import DepartmentsPage from './dashboard/DepartmentsPage';
import WelcomerPage from './dashboard/WelcomerPage';

export default function DashboardWrapper() {
  const { guildId } = useParams();
  const { user } = useAuth();
  const [guild, setGuild] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    guildsAPI.getOne(guildId)
      .then(res => {
        // Merge icon from JWT token — icon hash isn't stored in DB, comes from Discord OAuth
        const jwtGuild = user?.admin_guilds?.find(g => (typeof g === 'object' ? g.id : g) === guildId);
        setGuild({ ...res.data, icon: jwtGuild?.icon || null });
      })
      .catch(() => setError('Could not load server data.'))
      .finally(() => setLoading(false));
  }, [guildId, user]);

  if (loading) return (
    <div style={{
      minHeight: '100vh', display: 'flex',
      alignItems: 'center', justifyContent: 'center',
      background: 'var(--gradient-hero)',
    }}>
      <div style={{ textAlign: 'center', fontFamily: 'var(--font-body)' }}>
        <div style={{ fontSize: '48px', marginBottom: '16px' }}>🕐</div>
        <div style={{ color: 'var(--text-secondary)' }}>Loading server data...</div>
      </div>
    </div>
  );

  if (error) return (
    <div style={{
      minHeight: '100vh', display: 'flex',
      alignItems: 'center', justifyContent: 'center',
      background: 'var(--gradient-hero)',
    }}>
      <div style={{ textAlign: 'center', fontFamily: 'var(--font-body)' }}>
        <div style={{ fontSize: '48px', marginBottom: '16px' }}>❌</div>
        <div style={{ color: 'var(--danger)' }}>{error}</div>
      </div>
    </div>
  );

  return (
    <Routes>
      <Route element={<DashboardLayout guild={guild} />}>
        <Route index element={<Navigate to="overview" replace />} />
        <Route path="overview" element={<OverviewPage guild={guild} />} />
        <Route path="staff" element={<StaffPage guild={guild} />} />
        <Route path="shifts" element={<ShiftsPage guild={guild} />} />
        <Route path="ranks" element={<RanksPage guild={guild} />} />
        <Route path="payroll" element={<PayrollPage guild={guild} />} />
        <Route path="bonuses" element={<BonusesPage guild={guild} />} />
        <Route path="config" element={<ConfigPage guild={guild} setGuild={setGuild} />} />
        <Route path="panel" element={<PanelPage guild={guild} setGuild={setGuild} />} />
        <Route path="logs" element={<LogsPage guild={guild} />} />
        <Route path="welcomer" element={<WelcomerPage guild={guild} />} />
        <Route path="requests" element={<RequestsPage guild={guild} />} />
        <Route path="applications" element={<ApplicationsPage guild={guild} />} />
        <Route path="departments" element={<DepartmentsPage guild={guild} />} />
        <Route path="keys" element={<KeysPage />} />
        <Route path="partners" element={<PartnersPage />} />
        <Route path="subscription" element={<SubscriptionPage guild={guild} />} />
      </Route>
    </Routes>
  );
}
